import { matchRoutes, useLocation } from "react-router-dom-v5-compat";
import { Routes } from "../components/Navigation/navigationUtils";
const locationPageRoutes = [
    { path: Routes.LOCATION },
    { path: Routes.BASE_SKU },
    { path: `${Routes.BASE_SKU}/${Routes.LOCATION}` },
];
const orderFlowRoutes = [{ path: `${Routes.BASE_SKU}/${Routes.ORDER_FLOW}` }];
const accountRoutes = [{ path: Routes.ACCOUNT }];
const giftCardRoutes = [
    { path: Routes.GIFT_CARD },
    { path: Routes.GIFT_CARD_CHECKOUT },
    { path: Routes.GIFT_CARD_THANK_YOU },
];
const checkOutStepRoutes = [
    { path: `${Routes.BASE_SKU}/${Routes.CHECKOUT}` },
    { path: `${Routes.BASE_SKU}/${Routes.THANK_YOU}` },
];
const themPageRoute = [{ path: Routes.THEME }];
/**
 * Returns a boolean whether or not current route is in a specific path or set of paths
 * @param value
 * @returns
 */
export const useRouteMatch = () => {
    const location = useLocation();
    const isLocationPage = matchRoutes(locationPageRoutes, location);
    const isOrderFlowPage = matchRoutes(orderFlowRoutes, location);
    const isAccountSection = matchRoutes(accountRoutes, location);
    const isGiftCardFlow = matchRoutes(giftCardRoutes, location);
    const isCheckOutOrThankYouPage = matchRoutes(checkOutStepRoutes, location);
    const isThemePage = matchRoutes(themPageRoute, location);
    return {
        isLocationPage,
        isOrderFlowPage,
        isAccountSection,
        isGiftCardFlow,
        isCheckOutOrThankYouPage,
        isThemePage,
    };
};
